
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Update scrolled state on window scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    // Cleanup listener on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu whenever the route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const toggleMenu = useCallback(() => {
    setMenuOpen((prev) => !prev);
  }, []);

  const navLinks = [
    { to: '/', label: 'Inicio' },
    { to: '/productos', label: 'Productos' },
    { to: '/contacto', label: 'Contacto' },
    { to: '/ubicacion', label: 'Ubicación' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`
        fixed top-0 left-0 right-0 z-50 transition-all duration-300
        ${scrolled ? 'bg-black shadow-lg' : 'bg-black/90'}
      `}
    >
      <div className="w-full px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-16 sm:h-20 lg:h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 sm:space-x-3 flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/0538348e5f7265469219be823f4b4c0f/eb8228feaf53da6f20b3f98030813076.jpeg"
              alt="Artaca Tactic Panama"
              className="h-10 w-10 sm:h-12 sm:w-12 lg:h-14 lg:w-14 object-contain"
            />
            <span className="text-white font-bold text-base sm:text-lg lg:text-xl whitespace-nowrap">
              ARTACA TACTIC
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`
                  transition-colors font-medium whitespace-nowrap
                  ${isActive(link.to) ? 'text-[#7cb342]' : 'text-white hover:text-[#7cb342]'}
                `}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* WhatsApp Button Desktop */}
          <a
            href="https://wa.me/50765358000"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:flex items-center space-x-2 bg-[#7cb342] hover:bg-[#689f38] text-white px-5 xl:px-6 py-2.5 xl:py-3 rounded-full transition-all font-semibold whitespace-nowrap cursor-pointer text-sm xl:text-base"
          >
            <i className="ri-whatsapp-line text-lg xl:text-xl w-5 h-5 flex items-center justify-center"></i>
            <span>6535-8000</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white text-2xl cursor-pointer p-2 -mr-2"
            onClick={toggleMenu}
            aria-label="Menú"
          >
            <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`
          lg:hidden bg-black border-t border-[#1a3a2e] overflow-hidden transition-all duration-300
          ${menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}
        `}
      >
        <div className="px-4 sm:px-6 py-4 space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`
                block transition-colors font-medium py-3 px-3 rounded-lg whitespace-nowrap
                ${isActive(link.to) ? 'text-[#7cb342] bg-[#1a3a2e]/50' : 'text-white hover:text-[#7cb342] hover:bg-[#1a3a2e]/30'}
              `}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="https://wa.me/50765358000"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center space-x-2 bg-[#7cb342] text-white px-6 py-3 rounded-full font-semibold mt-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl w-5 h-5 flex items-center justify-center"></i>
            <span>6535-8000</span>
          </a>
        </div>
      </div>
    </nav>
  );
}
